import "./bootstrap";
import $ from "jquery";
window.$ = window.jQuery = $;
import * as bootstrap from "bootstrap";
import { tns } from "tiny-slider/src/tiny-slider";
window.tns = tns;
import { entrance } from "scroll-entrance/dist/scroll-entrance";
const Cookies = require("js-cookie");
const lightbox = require("lightbox2");
import Cropper from "./cropperjs";

import "select2";
import "select2/dist/js/i18n/pl";
import "./script";
import "./contact_form_walid";
import "./walid_modalForm";
import "./walid_modalTestdrive";
import "./walid_modalAccessories";
import "./walid_marketForm";
import "./visit_service";
import "./modelScript";
import "./history";
import "./calculatorLeasing";
import "./lpg_page";
import "./submit";

import L from "leaflet";
import "leaflet.markercluster";
import { OpenStreetMapProvider, GeoSearchControl } from "leaflet-geosearch";
window.OpenStreetMapProvider = OpenStreetMapProvider;
window.GeoSearchControl = GeoSearchControl;

$(document).ready(function () {
    var utmSource = "";
    var utmMedium = "";
    var utmCampaign = "";
    var url = window.location.href;

    if (url.includes("?")) {
        var parts = url.split("?");
        var params = parts[1].split("&");

        params.forEach(function (param) {
            var paramName = param.split("=")[0];
            var paramValue = param.split("=")[1];

            if (paramName === "utm_source") {
                utmSource = paramValue;
            } else if (paramName === "utm_medium") {
                utmMedium = paramValue;
            } else if (paramName === "utm_campaign") {
                utmCampaign = paramValue;
            }
        });
        document.cookie = "utmSource=" + utmSource + "; path=/";
        document.cookie = "utmMedium=" + utmMedium + "; path=/";
        document.cookie = "utmCampaign=" + utmCampaign + "; path=/";
    }
});
